module.exports = __webpack_public_path__ + "static/media/walnut.a201671b.png";